module.exports = __webpack_public_path__ + "static/img/红色党建@2x (1).8e1344e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/红色党建@2x (1).png
// module id = 2XLN
// module chunks = 1